export const EMPTY_OBJECT = Object.freeze(Object.create(null));
//# sourceMappingURL=emptyObject.js.map